<div class="fullcontainer pr-3">
  <div class="sheet">
    <div class="titleContainer">
      <h1 class="header">Report Builder</h1>
    </div>

    <p class="text-muted">
      Build a report on the fly across the system - orders, accounts, jobs, invoices, credit limits
      and stock movements - without waiting on a developer to write one. "Basic" lists and filters
      one entity's records with its usual filtering and CSV export; "Aggregate" groups and totals
      across it, with joins to related records.
    </p>

    <div class="row content-block p-3">
      <div class="col-4">
        <button class="btn btn-block btn-primary" routerLink="/report-builder/aggregate">
          <i class="fas fa-chart-bar"></i> Aggregate Report Builder
        </button>
      </div>
    </div>

    @if (this.loadFailed) {
      <div class="alert alert-danger mb-0"><strong>The report builder schema could not be loaded.</strong></div>
    }

    @if (this.schemas.length > 0) {
      <hr>
      <h2 class="header" style="font-size: 1.1rem;">Basic - list one entity</h2>
      <div class="row content-block p-3">
        @for (item of this.schemas; track item.key) {
          <div class="col-4">
            <button class="btn btn-block btn-secondary" [routerLink]="['/report-builder/basic', item.key]">
              {{ item.label }}
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>
